import React from 'react';

function SuperAdminLayout(props) {
  var children = props.children;
  var user = JSON.parse(localStorage.getItem('bhamsa_sa_user') || '{}');
  var path = window.location.pathname;

  var navItems = [
    { to: '/super-admin/dashboard',     icon: '📊', label: 'Dashboard' },
    { to: '/super-admin/admins',        icon: '👥', label: 'Admins' },
    { to: '/super-admin/plans',         icon: '📋', label: 'Plans & Billing' },
    { to: '/super-admin/leads', icon: '📥', label: 'Leads' },
    { to: '/super-admin/notifications', icon: '🔔', label: 'Notifications' },
    
  ];

  var handleLogout = function() {
    localStorage.removeItem('bhamsa_sa_token');
    localStorage.removeItem('bhamsa_sa_user');
    window.location.href = '/super-admin/login';
  };

  return React.createElement('div', { className: 'app-layout' },
    React.createElement('aside', {
      className: 'sidebar',
      style: { borderRight: '2px solid var(--accent)' }
    },
      React.createElement('div', { className: 'sidebar-logo' },
        React.createElement('div', {
          className: 'logo-title',
          style: { color: 'var(--accent)' }
        }, '👑 Bhamsa'),
        React.createElement('div', { className: 'logo-sub' }, 'Super Admin Panel')
      ),
      React.createElement('nav', { className: 'nav-section' },
        navItems.map(function(item) {
          return React.createElement('a', {
            key: item.to,
            href: item.to,
            className: path === item.to ? 'nav-item active' : 'nav-item',
          },
            React.createElement('span', { className: 'nav-icon' }, item.icon),
            item.label
          );
        })
      ),
      React.createElement('div', { style: { padding: '12px 20px' } },
        React.createElement('div', {
          style: { background: 'var(--bg3)', borderRadius: 8, padding: 12, fontSize: 12 }
        },
          React.createElement('div', { style: { color: 'var(--text3)', marginBottom: 6 } }, 'Shop Admin Panel:'),
          React.createElement('a', { href: '/login', style: { color: 'var(--accent2)', fontSize: 12 } }, '→ Shop Login kholo')
        )
      ),
      React.createElement('div', { className: 'sidebar-footer' },
        React.createElement('div', { className: 'sidebar-user' }, user ? user.name : ''),
        React.createElement('div', { className: 'sidebar-role' }, '👑 Super Admin'),
        React.createElement('button', {
          onClick: handleLogout,
          className: 'btn btn-ghost btn-sm',
          style: { marginTop: 10, width: '100%' }
        }, '🚪 Logout')
      )
    ),
    React.createElement('main', { className: 'main-content' },
      React.createElement('div', { className: 'topbar' },
        React.createElement('div', { className: 'topbar-title' }, '👑 Bhamsa Super Admin'),
        React.createElement('div', { className: 'topbar-right' },
          React.createElement('span', { style: { fontSize: 12, color: 'var(--text3)' } },
            new Date().toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'short' })
          )
        )
      ),
      children
    )
  );
}

export default SuperAdminLayout;